import * as React from "react";
import {CONST_MALE} from "../../PatientDynamicItems/OnChangeUtils";
import {ICON_PATIENT_FEMALE, ICON_PATIENT_MALE} from "../PatientDetails/Constants";

export const genderTemplate = (rowData) => {
    const genderIcon = rowData.gender === CONST_MALE ? ICON_PATIENT_MALE : ICON_PATIENT_FEMALE;
    return <i style={{fontSize: "18px"}}
              className={genderIcon}/>
}
